!function() {
  var __webpack_modules__ = {
    837: function() {
      window.Shopify = window.Shopify || {}, window.Shopify.MultiStore = window.Shopify.MultiStore || {}, 
      window.Shopify.MultiStore = [ {
        storeCode: "GB",
        storeName: "United Kingdom",
        storeUrl: "https://www.thisworks.com",
        supportedCountries: "AE,AF,AG,AI,AM,AO,AQ,AR,AS,AW,AZ,BB,BD,BF,BH,BI,BJ,BM,BN,BO,BQ,BR,BS,BT,BW,BZ,CA,CF,CG,CH,CI,CL,CM,CN,CO,CR,CU,CV,DJ,DM,DO,DZ,EC,EG,EH,ER,ET,FK,GA,GB,GD,GD,GF,GH,GM,GN,GP,GQ,GT,GW,GY,HK,HN,HT,ID,IL,IN,IO,IQ,IR,JM,JO,JP,KE,KG,KH,KM,KR,KW,KY,KZ,LA,LB,LC,LK,LR,LS,LY,MA,MG,ML,MM,MN,MO,MQ,MR,MS,MU,MV,MW,MX,MY,MZ,NA,NE,NG,NI,NP,OM,PA,PE,PG,PH,PK,PR,PY,QA,RU,RW,SA,SC,SD,SG,SL,SN,SO,SR,ST,SV,SX,SY,SZ,TD,TG,TH,TJ,TM,TN,TR,TT,TW,TZ,UA,UG,UY,UZ,VE,VG,VI,VN,YE,ZA,ZM,ZW"
      }, {
        storeCode: "EU",
        storeName: "Europe",
        storeUrl: "https://eu.thisworks.com",
        supportedCountries: "AD,AL,AM,AT,AX,BA,BE,BG,BY,CY,CZ,DE,DK,EE,ES,FI,FO,FR,GE,GG,GI,GR,HR,HU,IE,IS,IT,JE,LC,LT,LU,LV,MC,MK,MT,NL,NO,PL,PT,RO,SE,SI,SK,SM,UA,VA"
      }, {
        storeCode: "US",
        storeName: "United States",
        storeUrl: "https://us.thisworks.com",
        supportedCountries: "US"
      } ];
    },
    624: function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
      "use strict";
      if (__webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, {
        scrollend: function() {
          return o;
        }
      }), "undefined" != typeof window && !("onscrollend" in window)) {
        const i = new Event("scrollend"), s = new Set;
        document.addEventListener("touchstart", (e => {
          for (let t of e.changedTouches) s.add(t.identifier);
        }), {
          passive: !0
        }), document.addEventListener("touchend", (e => {
          for (let t of e.changedTouches) s.delete(t.identifier);
        }), {
          passive: !0
        }), document.addEventListener("touchcancel", (e => {
          for (let t of e.changedTouches) s.delete(t.identifier);
        }), {
          passive: !0
        });
        let l = new WeakMap;
        function e(e, t, n) {
          let o = e[t];
          e[t] = function() {
            let e = Array.prototype.slice.apply(arguments, [ 0 ]);
            o.apply(this, e), e.unshift(o), n.apply(this, e);
          };
        }
        function t(e, t, n, o) {
          if ("scroll" != t && "scrollend" != t) return;
          let r = this, d = l.get(r);
          if (void 0 === d) {
            let t = 0;
            d = {
              scrollListener: e => {
                clearTimeout(t), t = setTimeout((() => {
                  s.size ? setTimeout(d.scrollListener, 100) : (r && r.dispatchEvent(i), t = 0);
                }), 100);
              },
              listeners: 0
            }, e.apply(r, [ "scroll", d.scrollListener ]), l.set(r, d);
          }
          d.listeners++;
        }
        function n(e, t, n) {
          if ("scroll" != t && "scrollend" != t) return;
          let o = this, i = l.get(o);
          void 0 !== i && (i[t]--, --i.listeners > 0 || (e.apply(o, [ "scroll", i.scrollListener ]), 
          l.delete(o)));
        }
        e(Element.prototype, "addEventListener", t), e(window, "addEventListener", t), e(document, "addEventListener", t), 
        e(Element.prototype, "removeEventListener", n), e(window, "removeEventListener", n), 
        e(document, "removeEventListener", n);
      }
      var o = {
        __proto__: null
      };
    }
  }, __webpack_module_cache__ = {};
  function __webpack_require__(moduleId) {
    var cachedModule = __webpack_module_cache__[moduleId];
    if (void 0 !== cachedModule) return cachedModule.exports;
    var module = __webpack_module_cache__[moduleId] = {
      exports: {}
    };
    return __webpack_modules__[moduleId](module, module.exports, __webpack_require__), 
    module.exports;
  }
  __webpack_require__.d = function(exports, definition) {
    for (var key in definition) __webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key) && Object.defineProperty(exports, key, {
      enumerable: !0,
      get: definition[key]
    });
  }, __webpack_require__.o = function(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }, __webpack_require__.r = function(exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, function() {
    "use strict";
    __webpack_require__(837);
    function js_cookie_assign(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) target[key] = source[key];
      }
      return target;
    }
    var api = function init(converter, defaultAttributes) {
      function set(name, value, attributes) {
        if ("undefined" != typeof document) {
          "number" == typeof (attributes = js_cookie_assign({}, defaultAttributes, attributes)).expires && (attributes.expires = new Date(Date.now() + 864e5 * attributes.expires)), 
          attributes.expires && (attributes.expires = attributes.expires.toUTCString()), name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
          var stringifiedAttributes = "";
          for (var attributeName in attributes) attributes[attributeName] && (stringifiedAttributes += "; " + attributeName, 
          !0 !== attributes[attributeName] && (stringifiedAttributes += "=" + attributes[attributeName].split(";")[0]));
          return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
      }
      return Object.create({
        set: set,
        get: function(name) {
          if ("undefined" != typeof document && (!arguments.length || name)) {
            for (var cookies = document.cookie ? document.cookie.split("; ") : [], jar = {}, i = 0; i < cookies.length; i++) {
              var parts = cookies[i].split("="), value = parts.slice(1).join("=");
              try {
                var found = decodeURIComponent(parts[0]);
                if (jar[found] = converter.read(value, found), name === found) break;
              } catch (e) {}
            }
            return name ? jar[name] : jar;
          }
        },
        remove: function(name, attributes) {
          set(name, "", js_cookie_assign({}, attributes, {
            expires: -1
          }));
        },
        withAttributes: function(attributes) {
          return init(this.converter, js_cookie_assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
          return init(js_cookie_assign({}, this.converter, converter), this.attributes);
        }
      }, {
        attributes: {
          value: Object.freeze(defaultAttributes)
        },
        converter: {
          value: Object.freeze(converter)
        }
      });
    }({
      read: function(value) {
        return '"' === value[0] && (value = value.slice(1, -1)), value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
      },
      write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
      }
    }, {
      path: "/"
    });
    __webpack_require__(624);
    window.Geo = new class {
      cookie=!1;
      domain=(() => location.host.includes("thisworks.com") ? ".thisworks.com" : location.host)();
      setGeolocationCookie(country) {
        api.set("geolocation", country, {
          expires: 30,
          domain: this.domain
        });
      }
      getGeolocationCookie() {
        try {
          let cookie = api.get("geolocation");
          return !!cookie && (cookie.length > 3 && (cookie = JSON.parse(cookie), cookie = cookie.handle), 
          api.get("geolocation"));
        } catch (e) {
          return !1;
        }
      }
      async getLocation() {
        let callback = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        fetch(Shopify.routes.root + "browsing_context_suggestions.json").then((response => response.json())).then((json => {
          callback && callback(json.detected_values.country.handle);
        })).catch((error => {
          console.warn(error);
        }));
      }
      perform() {
        let callback = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.cookie = this.getGeolocationCookie(), this.cookie ? callback && callback(this.cookie) : this.getLocation(callback);
      }
      constructor() {
        window.Geo = this;
      }
    }, new class {
      loading=[];
      header=(() => document.querySelector("header"))();
      async importScript(el) {
        const tagName = el.tagName.toLowerCase(), devMode = "127.0.0.1" === location.hostname || Shopify && Shopify.theme && -1 !== Shopify.theme.name.indexOf("Development") || Shopify.designMode;
        if (Shopify = Shopify || {}, Shopify.devMode = devMode, -1 === this.loading.indexOf(tagName) && (this.loading.push(tagName), 
        !customElements.get(tagName))) {
          var scriptTag = document.createElement("script");
          scriptTag.src = `${window.settings.asset_url || "/assets/"}${tagName}.js?v=${devMode ? Date.now() : window.settings.asset_revision || Date.now()}`, 
          scriptTag.async = !0, devMode && (scriptTag.onload = () => console.info(`Loaded: ${tagName}`)), 
          scriptTag.onerror = () => console.warn(`Failed to load ${tagName}.`) && this.loading.splice(this.loading.indexOf(tagName)), 
          document.body.appendChild(scriptTag);
        }
      }
      loadScript(el) {
        if (el.hasAttribute("data-autoload")) this.importScript(el); else {
          new IntersectionObserver((async (entries, observer) => {
            entries.forEach((async entry => {
              entry.isIntersecting && this.importScript(el) && observer.disconnect();
            }));
          }), {
            rootMargin: "0px 0px 100% 0px"
          }).observe(el);
        }
      }
      initJavascript() {
        document.querySelectorAll("[data-async]").forEach((el => this.loadScript(el)));
        new MutationObserver(((mutationsList, observer) => {
          mutationsList.forEach((mutation => {
            mutation.target.querySelectorAll("[data-async]").forEach((el => this.loadScript(el)));
          }));
        })).observe(document.querySelector("body"), {
          childList: !0,
          subtree: !0,
          characterData: !1,
          attributes: !1
        });
      }
      initCloser() {
        document.addEventListener("keydown", (event => {
          "Escape" === event.key && document.querySelectorAll("details").forEach((el => el.open = !1)), 
          document.body.classList.remove("tablet:overflow-clip");
        }));
      }
      initClicks() {
        document.body.addEventListener("click", (event => {
          if (event.target.getAttribute("href")?.toLowerCase().includes("#cookies")) {
            if (window.OneTrust) return event.preventDefault(), OneTrust.ToggleInfoDisplay(), 
            !1;
          } else event.target.hasAttribute("onclick") || event.target.closest("details-disclosure") || document.querySelectorAll("details-disclosure details").forEach((details => details.open = !1));
        }));
      }
      visualViewport() {
        document.documentElement.style.setProperty("--visual-viewport", `${window.visualViewport.height}px`), 
        document.documentElement.style.setProperty("--header-height", `${(document.querySelector("[data-header]") || document.querySelector("header"))?.clientHeight}px`), 
        document.documentElement.style.setProperty("--header-height-full", document.querySelector("header")?.clientHeight - 1 + "px");
      }
      scrollTrigger() {
        const trigger = document.querySelector("[data-scroll-trigger]");
        if (trigger) {
          new IntersectionObserver((entries => {
            entries[0].isIntersecting ? document.body.classList.remove("is-scrolled") : document.body.classList.add("is-scrolled");
          })).observe(trigger);
        }
      }
      checkLocation() {
        try {
          window.Geo.perform((country => {
            country.length > 3 && (country = (country = JSON.parse(country)).handle);
            const supportedCountries = window.Shopify.MultiStore.find((store => store.storeCode == window.Shopify.CurrentStore.code))?.supportedCountries.split(",");
            if (!supportedCountries.includes(country)) {
              const modal = document.getElementById("Country"), select = modal.querySelector('[name="country_code"]');
              select.querySelector(`option[value="${country}"]`) && (select.value = country, modal.querySelector("[data-name]") && (modal.querySelector("[data-name]").textContent = select.selectedOptions[0]?.textContent), 
              modal.querySelector("[data-flag]") && (modal.querySelector("[data-flag]").src = modal.querySelector("[data-flag]").src.replace(/([a-z]{2})\.svg$/, `${select.selectedOptions[0]?.value.toLowerCase()}.svg`))), 
              modal.open = !0;
            }
          }));
        } catch (e) {
          console.error("Error checking location: ", e);
        }
      }
      constructor() {
        this.initJavascript(), this.initCloser(), this.checkLocation(), this.initClicks(), 
        this.scrollTrigger(), document.addEventListener("DOMContentLoaded", (() => {
          this.visualViewport(), (window.visualViewport || window).addEventListener("resize", debounce(this.visualViewport, 500), {
            passive: !0
          });
        })), !1 in window && Promise.resolve().then(__webpack_require__.bind(__webpack_require__, 624)), 
        window.addEventListener("load", (() => {
          const url = window.location.href;
          if (url.includes("form_type=customer")) {
            var id = (id = url.split("#")).length > 1 ? id[id.length - 1] : "footer", form = document.querySelector(`#${id}`) || document.querySelector('footer[action^="/contact"]');
            if (form) {
              const input = form.querySelector('[type="email"]');
              if (input && input.value.length > 0) {
                const el = document.createElement("p");
                el.classList.add("mt-sm", "text-red"), el.innerText = window.strings.newsletter.existing, 
                form.appendChild(el), window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                  event: "newsletter_signup",
                  form_action: "submit-failure",
                  error_id: window.strings.newsletter.existing
                });
              }
            }
          }
        }));
      }
    };
  }();
}();